export default __webpack_public_path__ + "static/media/svg-chart.db8af79e.svg";